export default "__VITE_ASSET__e3f3729d__"